import { Injectable } from '@angular/core';
import { Action, ActionReducer, combineReducers } from '@ngrx/store';

import * as fromAnyObject from '../reducers/any-object.reducer';
import * as fromCommonObjectList from '../reducers/common-object-list-uniqueId.reducer';

@Injectable()
export class ReducerGeneratorService {

	public createReducers(name: string, type: string): ActionReducer<any, Action> {
		if (type === 'list') {
			return fromCommonObjectList.createReducerWithName(name);
		} else {
			return fromAnyObject.createReducerWithName(name);
		}
	}
}

export function generateReducers(config: any): ActionReducer<any, Action> {
	if (config) {
		const keys = Object.keys(config);
		if (keys && keys.length) {
			const reducers = {};
			keys.forEach(key => {
				const each = config[key];
				if (each.name) {
					if (each.storeAsList) {
						reducers[each.name] = fromCommonObjectList.createReducerWithName(each.name);
					} else {
						reducers[each.name] = fromAnyObject.createReducerWithName(each.name);
					}
				}
			});
			return combineReducers(reducers);
		}
	}
}
